import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function CyberUWAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <path
        fill="#fff"
        d="M113.45,51.51c1.78,30.4-9.07,55.62-38.01,70.99-2.42-.56-4.17-1.62-6.15-2.86-25.78-16.04-34.56-40.33-32.68-68.71.08-1.21,1.35-2.24,2.56-2.23,12.52.12,24-3.13,33.72-10.34.77-.57,2.4-1.2,3.28-.63,3.66,2.4,6.99,4.77,10.96,6.47,7.37,3.16,14.94,4.67,23.07,4.5,1.84-.04,3.15,1.1,3.25,2.8ZM77.51,56.13c5.53.92,9.74,5.6,9.83,10.62l.14,8.39,6.71-.08-.23-7.62c-.21-6.89-4.2-12.72-10.26-15.58-6.75-3.18-14.3-2.47-20.27,1.61-4.24,2.9-7.27,7.93-7.32,12.79l-.09,8.82,6.36.08.08-8.36c.06-7.05,7.33-11.96,15.08-10.68ZM95.81,76.7l-12.32.06c-1.11,3.54-3.5,6.25-7.25,6.75-4.82.64-8.87-2.41-9.94-6.78l-12.31.03c-1.4,5.33-1.84,10.5-.49,15.78.34,1.34,1,2.71,1.59,4.04,3.1,7.07,9.73,12.56,17.9,13.45,4.6.5,8.43-.83,12.18-2.76,3.15-1.62,5.42-3.68,7.28-6.51,5.1-7.76,5.76-14.98,3.35-24.05Z"
      />
      <path
        fill="#fff"
        d="M77.83,94.6c0-1.46-1.27-2.64-2.83-2.64s-2.83,1.18-2.83,2.64c0,.9.48,1.68,1.21,2.16v6.92h3.24v-6.92c.73-.48,1.21-1.27,1.21-2.16Z"
      />
    </svg>
  );
}
